import ComparisonGroupProduct from '@/types/comparison-group-product';
import Portfolio from '@/types/portfolio';
import GenericContact from '@/types/generic-contact';
import { Dictionary } from 'lodash';

/**
 * Retrieves a list of unique contacts associated with the given comparison group products.
 *
 * @param products - An array of ComparisonGroupProduct objects representing the products in the comparison group.
 * @param portfolios - A dictionary of Portfolio objects keyed by their IDs.
 * @returns An array of unique GenericContact objects associated with the products.
 */
export const getContactsOfComparisonItemGroup = (products: ComparisonGroupProduct[], portfolios: Dictionary<Portfolio>): GenericContact[] => {
  const foundContactIds = new Set<string>();
  const contacts: GenericContact[] = [];

  products.forEach(product => {
    const contact = portfolios[product.itemId]?.contact;
    if (contact?._id && !foundContactIds.has(contact._id)) {
      foundContactIds.add(contact._id);
      contacts.push(contact);
    }
  });

  return contacts;
};
